import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import Modal from '../ui/Modal';

const CancelModal = () => {
  const app = useAppContext();

  return (
    <Modal
      isOpen={app.showCancelConfirmModal}
      onClose={() => app.setShowCancelConfirmModal(false)}
      size="sm"
    >
      <div className="modal__header">
        <div className="modal__icon-wrapper modal__icon-wrapper--danger">
          <AlertTriangle size={28} />
        </div>
        <h2 className="modal__title">Cancel Subscription</h2>
        <p className="modal__subtitle">
          Are you sure you want to cancel your AlphaNQ subscription?
        </p>
      </div>

      <div className="modal__body">
        <p className="confirm-modal__note">
          You can resubscribe anytime to regain full access
        </p>

        <div className="confirm-modal__actions">
          <button className="btn btn-danger btn-full" onClick={app.handleCancelSubscription}>
            Yes, Cancel Subscription
          </button>
          <button
            className="btn btn-secondary btn-full"
            onClick={() => app.setShowCancelConfirmModal(false)}
          >
            Keep My Subscription
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CancelModal;
